import { render } from "./ContentWrapper.vue?vue&type=template&id=04e2d0c6&ts=true"
import script from "./ContentWrapper.vue?vue&type=script&lang=ts"
export * from "./ContentWrapper.vue?vue&type=script&lang=ts"

import "./ContentWrapper.vue?vue&type=style&index=0&id=04e2d0c6&lang=scss"

import exportComponent from "/opt/source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__